
import {FC} from "react";

import React from 'react';

import ControlAcceptorForm from "../../forms/claim-handling-forms/control-acceptor-form";

interface Interface{
    partSource: any;
    requestId: any;
    mode?: "View" | "Add new";
    onClose?: () => void;
}

const ControlAcceptorScreen: FC<Interface> = (props:any) => {

    

    return (
            
                <ControlAcceptorForm
                    requestId={props.requestId}
                    partSource={props.partSource}
                    mode={props.mode}
                />
            
    );
}
export default ControlAcceptorScreen;
